import { combineReducers } from "redux";
import { GET_GRAPH_URINE, GET_GRAPH_URINE_FAILED, GET_GRAPH_URINE_SUCCESS } from "store/actions/graph";


const initialState = {
    isLoading: false,
    data: [],
}

/**
 * auth reducer
 * @param {object} state
 * @param {object} action
 * @returns
 */
function graphUrine(state = initialState, action) {
    switch (action.type) {
        case GET_GRAPH_URINE:
            return {
                ...state,
                isLoading: true,
            }
        case GET_GRAPH_URINE_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoading: false,
            }

        case GET_GRAPH_URINE_FAILED:
            return {
                ...state,
                isLoading: false,
            }
        default:
            return state
    }
}

export default combineReducers({
    graphUrine,
})

